var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-10"},[_c('section',{staticClass:"content"},[_c('v-row',{staticClass:"align-md-stretch"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }